import styled, { css } from 'styled-components'
import {
  AlignSelfType,
  BorderType,
  HoverType,
  PaddingType,
} from 'common/types/styleTypes'
import {
  fontCss,
  mobileFontCss,
  FontProps,
  paddingsCss,
  mobilePaddingsCss,
  borderCss,
  mobileBorderCss,
  boxShadowCss,
  mobileBoxShadowCss,
  lineHeightCss,
  mobileLineHeightCss,
  hoverCss,
  mobileHoverCss,
  hoverTransformCss,
  mobileHoverTransformCss,
  backgroundCss,
  mobileBackgroundCss,
  hoverTransitionCss,
  mobileHoverTransitionCss,
} from 'common/utils/styleUtilsNew'

type LinkUiProps = {
  background?: string
  mobileBackground?: string
  color?: string
  mobileColor?: string
  padding?: Partial<PaddingType>
  mobilePadding?: Partial<PaddingType>
  width?: 'auto' | '100%'
  mobileWidth?: 'auto' | '100%'
  border?: Partial<BorderType>
  mobileBorder?: Partial<BorderType>
  alignSelf?: AlignSelfType
  mobileAlignSelf?: AlignSelfType
  boxShadow?: string
  mobileBoxShadow?: string
  lineHeight?: number
  mobileLineHeight?: number
  hover?: HoverType
  mobileHover?: HoverType
} & FontProps

const LinkUi = styled.a<LinkUiProps>`
  text-align: center;
  &:disabled {
    cursor: default;
    opacity: 0.7;
  }
  width: ${p => p.width || 'auto'};
  align-self: ${p => p.alignSelf || 'center'};
  cursor: pointer;
  ${backgroundCss}
  ${paddingsCss}
  ${fontCss}
  ${borderCss}
  ${boxShadowCss}
  ${lineHeightCss}
  ${hoverCss}
  ${hoverTransformCss}
  ${hoverTransitionCss}

  ${p => p.theme.phone} {
    width: ${p => p.mobileWidth || '100%'};
    align-self: ${p => p.mobileAlignSelf || 'center'};
    ${mobileBackgroundCss}
    ${mobilePaddingsCss}
    ${mobileFontCss}
    ${mobileBorderCss}
    ${mobileBoxShadowCss}
    ${mobileLineHeightCss}
    ${mobileHoverCss}
    ${mobileHoverTransformCss}
    ${mobileHoverTransitionCss}
  }

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      ${mobileHoverCss}
      ${mobileHoverTransformCss}
      ${mobileHoverTransitionCss}
      ${mobileBackgroundCss}
      ${mobilePaddingsCss}
      ${mobileBorderCss}
      ${mobileFontCss}
      ${mobileBoxShadowCss}
      ${mobileLineHeightCss}
      width: ${p.mobileWidth || '100%'};
      align-self: ${p.mobileAlignSelf || 'center'};
    `}
`

export default LinkUi
